import React from "react";
import { Tooltip } from "src/components";

export interface POWarehouseCheckInTooltipProps {
  totalExpectedBoxesQty?: number;
  purchaseOrderId: string;
  origin?: string;
}

export const POWarehouseCheckInTooltip: React.FC<POWarehouseCheckInTooltipProps> = ({
  totalExpectedBoxesQty,
  purchaseOrderId,
  origin
}) => {
  const message = (
    <div>
      {totalExpectedBoxesQty ? (
        <p>
          The expected number of boxes for this purchase order ({purchaseOrderId}) is {totalExpectedBoxesQty} boxes.
        </p>
      ) : (
        <p>The purchase order number for the current check-in is {purchaseOrderId}.</p>
      )}
      {origin && <p>Origin: {origin}</p>}
    </div>
  );

  return <Tooltip message={message} iconSize={18} />;
};
